import { NgModule } from '@angular/core';
import { SafePipe } from '@app/pipes/safe-pipe';
import { CapitalizePipe } from '@app/pipes/capitalize.pipe';
import { UnslugifyPipe } from '@app/pipes/unslugify.pipe';
import { ReferrerPipe } from '@app/pipes/referrer.pipe';
import { DateAgoPipe } from '@app/pipes/date-ago-pipe';
import { DateUntilPipe } from '@app/pipes/date-until.pipe';
import { JsonLdPipe } from '@app/pipes/json-ld-pipe';
import { ImageResizePipe } from '@app/pipes/image-resize';
import { ImageCompressedPipe } from '@app/pipes/imageCompression.pipe';
import { SearchFilterPipe } from '@app/pipes/search-filter-pipe';
import { SlugifyPipe } from '@app/pipes/slugify.pipe';
import { StripHtmlPipe } from '@app/pipes/strip-html';
import { TranslatePipe } from '@app/pipes/translate.pipe';

@NgModule({
  declarations: [
    ReferrerPipe,
    UnslugifyPipe,
    CapitalizePipe,
    TranslatePipe,
    SafePipe,
    ImageResizePipe,
    ImageCompressedPipe,
    StripHtmlPipe,
    DateAgoPipe,
    SearchFilterPipe,
    SlugifyPipe,
    DateUntilPipe,
    JsonLdPipe,
  ],
  exports: [
    ReferrerPipe,
    UnslugifyPipe,
    CapitalizePipe,
    TranslatePipe,
    SafePipe,
    ImageResizePipe,
    ImageCompressedPipe,
    StripHtmlPipe,
    DateAgoPipe,
    SearchFilterPipe,
    SlugifyPipe,
    DateUntilPipe,
    JsonLdPipe,
  ],
  providers: [
    ReferrerPipe,
    UnslugifyPipe,
    CapitalizePipe,
    TranslatePipe,
    SafePipe,
    ImageResizePipe,
    ImageCompressedPipe,
    StripHtmlPipe,
    DateAgoPipe,
    SearchFilterPipe,
    SlugifyPipe,
    DateUntilPipe,
    JsonLdPipe,
  ],
})
export class SharedPipeModule {}
